export const SECTION_CONTAINER_TEST_IDS = {
  EXTRA_PRODUCT_HEADER: 'extra-product-section-header',
  SECTION_NAV: 'section-nav',
  SECTION_NAV_SCROLL_PREV: 'section-nav-scroll-prev',
  SECTION_NAV_SCROLL_NEXT: 'section-nav-scroll-next',
  OOS_FABRIC_MODAL: 'section-oos-fabric-modal',
  RESUME_AUTOSAVE_MODAL: 'resume-autosave-modal',
} as const;
